import TutorialContent from "./TutorialContent";
//repreater block wrapper
const Tutorial = ({data})  => {
    return(
        <>
        <section className="processes text-center p-top-70">
            <div className="container">
                <TutorialContent TutorialContent={data}></TutorialContent>
            </div>
        </section>
        </>
    );
}

export default Tutorial;